import React from "react";

import styles from "./styles.scss";
import { COMP_GREEN } from "../../../../colors";

interface ProgressBarProps {
  align: "left" | "right";
  value: number;
  containerClassName?: string;
  outerClassName?: string;
  innerClassName?: string;
}

const ProgressBar = (props: ProgressBarProps) => {
  const { align, value, containerClassName, outerClassName, innerClassName } = props;
  return (
    <div className={`progress__container ${containerClassName}`}>
      <div
        className={`progress__outer ${outerClassName}`}
        style={{
          justifyContent: align === "left" ? "flex-start" : "flex-end",
          backgroundColor: "#b5b5b5",
        }}
      >
        <div
          className={`progress__inner ${innerClassName}`}
          style={{
            width: `${value || 1}%`,
            backgroundColor: value > 50 ? COMP_GREEN : "#515151",
          }}
        />
      </div>
      <style jsx global>
        {styles}
      </style>
    </div>
  );
};

export default ProgressBar;
